import State from 'store/State';
import { WidgetId } from 'widgets/WidgetId';
import {
    buildBarRequest,
    MarketDataRequest,
} from 'marketData/MarketDataRequest';

import {
    getCandlestickRequestWithStreamKey,
    getCandlestickStreamRequestInfosForSymbols,
} from 'widgets/candlestickTile/api/CandlestickTileStreamRequest';
import {
    CandlestickTileConfigState,
    initialCandlestickTileConfigState,
} from 'widgets/candlestickTile/store/config/CandlestickTileConfigState';
import { DataServices } from 'store/Services';
import { selectAppSettings } from 'app/store/appSettings/selectors';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';

export async function getCandlestickMarketDataRequest(
    state: State,
    services: DataServices,
    id: WidgetId
): Promise<MarketDataRequest[]> {
    const request = await getCandlestickRequestWithStreamKey(
        state,
        services,
        id
    );
    if (!request) {
        return [];
    }
    const { payload } = request;
    const { bucketSize: payloadBucketSize, symbol, symbology } = payload;

    const bucketSize =
        payloadBucketSize ?? initialCandlestickTileConfigState.bucketSize;

    return [buildBarRequest(symbol, symbology as SymbologyValues, bucketSize)];
}

export async function getCandlestickMarketDataRequestForSymbols(
    state: State,
    services: DataServices,
    symbols: string[],
    config: CandlestickTileConfigState
): Promise<MarketDataRequest[]> {
    const infos = await getCandlestickStreamRequestInfosForSymbols(
        state,
        services,
        symbols,
        config
    );
    const { symbology: usersSymbology } = selectAppSettings(state);
    return infos.map((i) =>
        buildBarRequest(i.payload.symbol, usersSymbology, i.payload.bucketSize)
    );
}
